<template>
  <div class="richtext-editor">
     <el-form ref="form" label-width="80px">
      <el-form-item label="上边距">
        <el-slider v-model="currentItem.style.margin_top" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左右边距">
        <el-slider v-model="currentItem.style.padding" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="内容">
        <VueUEditor
          ueditorPath="/static/q_ueditor/"
          @ready="editorReady"
          style="width:400px">
        </VueUEditor>
      </el-form-item>
     </el-form>
  </div>
</template>
<script>
import VueUEditor from 'vue-ueditor'
export default {
  name: 'richtextEditor',
  components: {
    VueUEditor
  },
  data () {
    return {
      editorInstance: ''
    }
  },
  computed: {
    currentItem () {
      return this.$store.state.page.currentItem
    }
  },
  methods: {
    editorReady (editor) {
      this.editorInstance = editor
      editor.setContent(this.currentItem.content || '')
      this.editorInstance.addListener('contentChange', _ => {
        this.currentItem.content = this.editorInstance.getContent()
      })
    }
  },
  updated () {
    // this.$nextTick(() => {
    //   if (this.editorInstance) {
    //     this.editorInstance.setContent(this.currentItem.content)
    //   }
    // })
  },
  beforeDestroy () {
    // this.editorInstance.removeListener
  }
}
</script>
<style lang="less">
.richtext-editor {
  .el-form-item__content {
    line-height: 22px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageEditor/editors/richtextEditor.vue